import { c as _c } from "react/compiler-runtime";
import { Table, TableBody, TableCell, TableHead, TableRow } from '@repo/ui/components';
interface Props {
  data: {
    heading: string;
    value: null | number | string | undefined;
  }[];
}
export const DetailsTable = t0 => {
  const $ = _c(4);
  const {
    data
  } = t0;
  let t1;
  if ($[0] !== data) {
    t1 = data.map(_temp);
    $[0] = data;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <Table data-sentry-element="Table" data-sentry-component="DetailsTable" data-sentry-source-file="details-table.tsx"><TableBody data-sentry-element="TableBody" data-sentry-source-file="details-table.tsx">{t1}</TableBody></Table>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
function _temp(t0) {
  const {
    heading,
    value
  } = t0;
  return <TableRow key={heading + value}><TableHead>{heading}</TableHead><TableCell>{value}</TableCell></TableRow>;
}